import React from 'react';
import { TitleContentRow } from 'components/unique/careerDetail/titleContentRow';
import { DescriptionList } from 'components/unique/careerDetail/descriptionList';

type CareerDetailApplicationOverviewProps = {
  labels: string[];
  contents: string[];
};

export const CareerDetailApplicationOverview = ({ labels, contents }: CareerDetailApplicationOverviewProps) => {
  return (
    <TitleContentRow titleEn="Application\nOverview" titleJa="応募概要">
      <DescriptionList labels={labels} contents={contents} />
    </TitleContentRow>
  );
};
